import { isNil } from "lodash-es";
import BillingService from "../../../services/BillingService";
import { useCustomerState } from "../../../state/customer";
import { isValidDate } from "../../../utils/dateUtil";
import NewPlatformBanner from "./NewPlatformBanner.tsx";
import ScheduledForDeletionBanner from "./ScheduledForDeletionBanner";
import TrialBanner from "./TrialBanner";
import type { Banner } from "./banners";

export const banners: Banner[] = [
  {
    id: "new-platform",
    priority: 10,
    dismissable: true,
    useShouldDisplay: () => () => true,
    Component: NewPlatformBanner,
  },
  {
    id: "trial",
    priority: 80,
    useShouldDisplay: () => {
      const subscriptionStatusQuery = BillingService.getSubscriptionStatus();
      return () => subscriptionStatusQuery.isSuccess && subscriptionStatusQuery.data.trialing;
    },
    Component: TrialBanner,
  },
  {
    id: "scheduled-for-deletion",
    priority: 90,
    useShouldDisplay: () => {
      const customer = useCustomerState();
      return () => !isNil(customer.meta.deleteOn) && isValidDate(customer.meta.deleteOn);
    },
    Component: ScheduledForDeletionBanner,
  },
];
